const STORAGE_KEY = 'cp.sidebarProgramExpand.v2';

export type SidebarProgramExpandState = {
  fixed: boolean;
  project: boolean;
  track: boolean;
};

export function hasSidebarProgramExpandStored(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    return false;
  }
}

export function loadSidebarProgramExpand(): SidebarProgramExpandState {
  const fallback: SidebarProgramExpandState = { fixed: true, project: true, track: true };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return fallback;
    const o = parsed as Record<string, unknown>;
    return {
      fixed: typeof o.fixed === 'boolean' ? o.fixed : true,
      project: typeof o.project === 'boolean' ? o.project : true,
      track: typeof o.track === 'boolean' ? o.track : true,
    };
  } catch {
    return fallback;
  }
}

export function saveSidebarProgramExpand(state: SidebarProgramExpandState): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore quota / private mode */
  }
}
